import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.953 12c0 .844-.703 1.5-1.5 1.5h-1.5L24 21v1.172a1.88 1.88 0 0 1-1.875 1.875h-.75c-.094 0-.14 0-.187-.047-.047.047-.141.047-.188.047L19.5 24h-1.125c-1.078 0-1.875-.797-1.875-1.875V18c0-.797-.703-1.5-1.5-1.5h-3c-.844 0-1.5.703-1.5 1.5v4.125A1.85 1.85 0 0 1 8.625 24h-3.75C3.797 24 3 23.203 3 22.125V13.5H1.5A1.48 1.48 0 0 1 0 12c0-.422.14-.797.469-1.125l12-10.5C12.797.047 13.172 0 13.5 0s.703.094.984.328l11.954 10.547c.375.328.562.703.515 1.125"
    }, null, -1)
  ]))]))
}
export default { render: render }